"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.theme = (0, styles_1.createTheme)({
    typography: {},
    shape: { borderRadius: 4 },
    spacing: 8,
    overrides: {
        MuiTextField: {
            root: {
                borderRadius: 4,
                fontFamily: "Inter",
            },
        },
        MuiSelect: {
            root: {
                fontFamily: "Inter",
                fontSize: 14,
            },
        },
        MuiMenuItem: {
            root: {
                fontFamily: "Inter",
                fontSize: 14,
            }
        },
        MuiListItemText: {
            root: {
                fontFamily: "Inter",
                fontSize: 14,
            }
        },
        MuiTypography: {
            body1: {
                fontFamily: "Inter",
            }
        },
        MuiInputBase: {
            input: {
                fontFamily: "Inter",
                fontSize: 14,
            }
        },
        MuiOutlinedInput: {
            input: {
                "&::placeholder": {
                    fontStyle: 'italic'
                },
            }
        }
    },
});
